/**
 * Lazy Script Loader for Sacred Forest theme
 * Loads <script data-lazy-src="..."> when container enters viewport OR on user interaction.
 * Added 2026-04-20 — performance optimization
 */
(function() {
  if (!('IntersectionObserver' in window)) {
    // Fallback: load everything on load event
    window.addEventListener('load', function() {
      document.querySelectorAll('script[data-lazy-src]').forEach(loadScript);
    });
    return;
  }

  function loadScript(tag) {
    if (tag.dataset.loaded === 'true') return;
    tag.dataset.loaded = 'true';
    var s = document.createElement('script');
    s.src = tag.dataset.lazySrc;
    if (tag.dataset.lazyType) s.type = tag.dataset.lazyType;
    s.async = false;  // preserve order
    s.defer = true;
    tag.parentNode.insertBefore(s, tag.nextSibling);
  }

  // Load scripts when their nearest section is near viewport
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        entry.target.querySelectorAll('script[data-lazy-src]:not([data-loaded])').forEach(loadScript);
      }
    });
  }, {
    rootMargin: '400px'  // preload 400px before reaching element
  });

  // Observe all sections containing lazy scripts
  function observeAll() {
    document.querySelectorAll('script[data-lazy-src]:not([data-loaded])').forEach(function(tag) {
      var section = tag.closest('[class*="shopify-section"]') || tag.closest('section') || tag.parentElement;
      if (section) observer.observe(section);
      else loadScript(tag);  // fallback if no container
    });
  }

  // Also load on user interaction (click/touch) as backup
  var interactionLoaded = false;
  function loadAllOnInteraction() {
    if (interactionLoaded) return;
    interactionLoaded = true;
    document.querySelectorAll('script[data-lazy-src]:not([data-loaded])').forEach(loadScript);
  }
  ['pointerdown', 'keydown', 'touchstart'].forEach(function(ev) {
    window.addEventListener(ev, loadAllOnInteraction, {once: true, passive: true});
  });

  // Start after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }
  
  // Safety net: load remaining after window.load + 3s idle
  window.addEventListener('load', function() {
    setTimeout(function() {
      document.querySelectorAll('script[data-lazy-src]:not([data-loaded])').forEach(loadScript);
    }, 3000);
  });
})();
